import{useRef as r,useEffect as t}from"react";function u(){let e=r(!0);return t(()=>{e.current=!1},[]),e.current}export{u as useIsInitialRender};
